<template>
  <div class="home">
    <HeaderComponent screenName="" />
    <ContractVehiclesBannerComponent
      imageSrc="contracts-banner.jpg"
      heading="Contracts"
    />
    <div class="section-div">
      <div class="heading-title" data-aos="fade-up">
        <h1>Federal</h1>
      </div>
      <div>
        <ContractVehiclesSectionComponent
          v-for="(section, index) in sectionsData"
          :key="index"
          :image-url="require(`@/assets/contract vehicles/${section.imageName}`)"
          :heading="section.heading"
          :content="section.content"
          data-aos="fade-up"
        />
      </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';
import ContractVehiclesSectionComponent from '@/components/contract vehicles/ContractVehiclesSectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

interface Content {
  heading: string;
  text1: string;
  text2: string;
  text3: string;
}

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    ContractVehiclesSectionComponent,
    FooterComponent
  },
  data() {
    return {
      sectionsData: [
        {
          imageName: 'MDA1.png',
          heading: 'MDA SHIELD IDIQ',
          content: {
            redirectTo: '/mda-shield-idiq',
          }
        },
        {
          imageName: 'logo_img_2.jpg',
          heading: 'General Services Administration (GSA) Multiple Award Schedule (MAS), 47QTCA19D00HL – 54151S, Period of Performance: 8/2019 - 8/2039',
          content: {
            heading: 'Information Technology Professional Services - SIN <a href="https://www.gsaelibrary.gsa.gov/ElibMain/sinDetails.do?scheduleNumber=MAS&specialItemNumber=54151S&executeQuery=YES&filter=NO" style="color:blue">54151S</a>',
            text1: 'Information Technology Professional Services IT Professional Services and/or labor categories for database planning and design; systems analysis, integration, and design; programming, conversion and implementation support; network services, data/records management, and testing.',
            text2:'GSA Schedule Number - 47QTCA19D00HL',
            text3:'Please <a href="https://www.gsaadvantage.gov/advantage/ws/search/advantage_search?searchType=2&q=19:547QTCA19D00HL" target="_blank" style="color:blue">click here</a> to download the GSA pricelist.'
             
          }
        },
        {
          imageName: 'logo_img_2.jpg',
          heading: 'General Services Administration (GSA) Multiple Award Schedule (MAS) Highly Adaptive Cybersecurity Services, 47QTCA19D00HL – 54151HACS, Period of Performance: 8/2019 - 8/2039',
          content: {
            heading: 'Highly Adaptive Cybersecurity Services (HACS) - SIN <a href="https://www.gsaelibrary.gsa.gov/ElibMain/sinDetails.do?executeQuery=YES&scheduleNumber=MAS&flag=&filter=&specialItemNumber=54151HACS" style="color:blue">54151HACS</a> ',
            text1: 'Highly Adaptive Cybersecurity Services (HACS) includes a wide range of fields such as, the seven-step Risk Management Framework services, information assurance, virus detection, zero trust architecture, network management, situational awareness and incident response, secure web hosting, backups, security services and Security Operations Center (SOC) services. HACS vendors are cataloged under the 5 subcategories of High Value Asset Assessments, Risk and Vulnerability Assessments, Cyber Hunt, Incident Response, and Penetration Testing.',
            text2:'GSA Schedule Number - 47QTCA19D00HL',
            text3:'Please <a href="https://www.gsaadvantage.gov/advantage/ws/search/advantage_search?searchType=2&q=19:547QTCA19D00HL" target="_blank" style="color:blue">click here</a> to download the GSA pricelist.'
          }
        },
         {
          imageName: 'logo_img_2.jpg',
          heading: 'General Services Administration (GSA) Multiple Award Schedule (MAS) Health Information Technology Services, 47QTCA19D00HL – 54151HEAL	, Period of Performance: 8/2019 - 8/2039',
          content: {
            heading: 'Health Information Technology Services (HEAL) -SIN <a href="https://www.gsaelibrary.gsa.gov/ElibMain/sinDetails.do?executeQuery=YES&scheduleNumber=MAS&flag=&filter=&specialItemNumber=54151HEAL" style="color:blue">54151HEAL</a>',
            text1: 'Health Information Technology Services includes a wide range of Health IT services to include connected health, electronic health records, health information exchanges, health analytics, personal health information management, innovative Health IT solutions, health informatics, emerging Health IT research, and other Health IT services.',
            text2:'GSA Schedule Number - 47QTCA19D00HL',
            text3:'Please <a href="https://www.gsaadvantage.gov/advantage/ws/search/advantage_search?searchType=2&q=19:547QTCA19D00HL" target="_blank" style="color:blue">click here</a> to download the GSA pricelist.'
          }
        },
        {
          imageName: 'logo_img_2.jpg',
          heading: 'General Services Administration (GSA) Multiple Award Schedule (MAS) Cloud Computing and Cloud Related Professional Services, 47QTCA19D00HL – 518210C, Period of Performance: 6/2024 - 8/2044',
          content: {
            heading: 'Cloud Computing and Cloud Related IT Professional Services - SIN <a href="https://www.gsaelibrary.gsa.gov/ElibMain/sinDetails.do?executeQuery=YES&scheduleNumber=MAS&flag=&filter=&specialItemNumber=518210C" style="color:blue">518210C</a>',
            text1: 'Cloud Computing and Cloud Related IT Professional Services includes commercially available cloud computing services such as Infrastructure as a Service (IaaS), Platform as a Service (PaaS), and Software as a Service (SaaS) and emerging cloud computing services. IT professional services that are focused on providing the types of services that support the Governments adoption of, migration to, or governance/management of cloud computing. Specific cloud related IT professional labor categories and/or fixed-price professional services solutions that support activities associated with assessing cloud solutions, refactoring workloads for cloud solutions, migrating legacy or other systems to cloud solutions, providing management/governance of cloud solutions, DevOps, developing cloud native applications, or other cloud oriented activities are within scope of this SIN',
            text2:'GSA Schedule Number - 47QTCA19D00HL',
            text3:'Please <a href="https://www.gsaadvantage.gov/advantage/ws/search/advantage_search?searchType=2&q=19:547QTCA19D00HL" target="_blank" style="color:blue">click here</a> to download the GSA pricelist.'
          }
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>

<style scoped>
.heading-title {
  display: flex;
  justify-content: center;
}

.section-div {
  background-color: #f2f2f2;
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 55px;
  padding-bottom: 5px;
}

.heading-title h1 {
  font-size: 51px;
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  margin-bottom: 40px;
  color: rgb(53, 53, 53);
}

@media (max-width: 1200px) {
  .heading-title h1 {
    font-size: 47px;
  }
  .section-div {
    padding-top: 50px;
  }
  .heading-title h1 {
    margin-bottom: 35px;
  }
}

@media (max-width: 1100px) {
  .heading-title h1 {
    font-size: 44px;
  }
  .section-div {
    padding-top: 45px;
  }
  .heading-title h1 {
    margin-bottom: 30px;
  }
}

@media (max-width: 1000px) {
  .heading-title h1 {
    font-size: 41px;
  }
  .section-div {
    padding-top: 40px;
  }
  .heading-title h1 {
    margin-bottom: 25px;
  }
}

@media (max-width: 900px) {
  .heading-title h1 {
    font-size: 38px;
  }
  .section-div {
    padding-top: 35px;
    padding-left: 40px;
    padding-right: 40px;
  }
}

@media (max-width: 800px) {
  .heading-title h1 {
    font-size: 35px;
  }
  .section-div {
    padding-top: 30px;
    padding-left: 40px;
    padding-right: 40px;
  }
}

@media (max-width: 700px) {
  .heading-title h1 {
    font-size: 31px;
  }
  .section-div {
    padding-top: 25px;
    padding-left: 40px;
    padding-right: 40px;
  }
}

@media (max-width: 600px) {
  .heading-title h1 {
    font-size: 28px;
  }
  .section-div {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
  }
}
</style>